import axios from "axios";
import authHeader from "@/services/auth-header";
import config from "@/data/config";

const API_URL = config.baseURL;

export const log = {
   namespaced: true,
   state: {
      data: {},
   },
   getters: {
      // countAll: (state) => {return state.data.length},
      countAll(state) {
         return state.data.length;
      },
   },
   actions: {
      getAll({ commit, rootState }) {
         rootState.isLoading = true;
         axios.get(`${API_URL}log_activity`, { headers: authHeader() }).then(
            (response) => {
               commit("SET_DATA", response.data);
               rootState.isLoading = false;
            },
            () => {
               rootState.isLoading = false;
            }
         );
      }
   },
   mutations: {
      SET_DATA(state, data) {
         state.data = data;
      },
   },
};
